export default "__VITE_ASSET__BPTVhMF4__"